export default "__VITE_ASSET__yBN0Hmm9__"